import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Cloudinary } from '@cloudinary/url-gen';
import { AdvancedVideo } from '@cloudinary/react';
import { scale } from '@cloudinary/url-gen/actions/resize';
import { quality, format } from '@cloudinary/url-gen/actions/delivery';
var CloudinaryVideoPlayer = function (_a) {
    var publicId = _a.publicId;
    var _b = useState(null), cldVideo = _b[0], setCldVideo = _b[1];
    useEffect(function () {
        var cld = new Cloudinary({
            cloud: {
                cloudName: 'chaseit1416',
            },
        });
        // Create a CloudinaryVideo instance
        var video = cld.video(publicId);
        // Get the viewport width
        var viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        // Apply transformations based on viewport width
        if (viewportWidth < 400) {
            video.resize(scale().width(400)); // Scale to 400px width
        }
        else if (viewportWidth >= 400 && viewportWidth < 800) {
            video.resize(scale().width(800)); // Scale to 800px width
        }
        // Add quality and format transformations
        video.delivery(quality('auto')).delivery(format('auto'));
        // Set the transformed video
        setCldVideo(video);
    }, [publicId]);
    return (_jsx("div", { children: cldVideo && _jsx(AdvancedVideo, { cldVid: cldVideo, controls: true }) }));
};
export default CloudinaryVideoPlayer;
